;(function () {
  'use strict'

  angular.module('contrast.navigation.history').run(function (HistoryService) {
    HistoryService.init()
  })
})()
